<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div class="title">编辑</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">

                <el-form :model="editForm" :rules="rules" ref="editForm">

                        <el-row>
                          <el-col :span="12" class="item">
                            <el-form-item label="商家" required prop="businessCode">
                              <el-select v-model="editForm.businessCode" placeholder="请选择商家" style="width: 100%">
                                <el-option
                                    v-for="item in arr_business"
                                    :key="item.businessCode"
                                    :label="item.name"
                                    :value="item.businessCode">
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
                          <el-col :span="12" class="item">
                            <el-form-item label="手机号" required prop="phone">
                              <el-input v-model="editForm.phone" placeholder="请输入手机号"></el-input>
                            </el-form-item>
                          </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="姓名" required prop="name">
                                    <el-input v-model="editForm.name" placeholder="请输入服务人员姓名"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="身份证号" required prop="idCard">
                                    <el-input v-model="editForm.idCard" maxlength="18" placeholder="请输入身份证号"></el-input>
                                </el-form-item>
                            </el-col>

                        <el-col :span="12" class="item">
                          <el-form-item label="状态">
                            <el-select v-model="editForm.status" placeholder="选择状态" style="width: 100%">
                              <el-option
                                  v-for="item in status2"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>

                      </el-row>


                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

//     import idcardRules from "@/common/idcardRules";
//   const validatorIdNumber = (rule, value, callback) => {
//   if(value){
//     if (idcardRules(value)) {
//         callback();
//     } else {
//         return callback(new Error('请输入正确的证件号'))
//     }
//   }else{
//     callback()
//   }
//
// };

    export default {
        name: 'Add',
      props:['arr_business'],
        data() {
            return {
                loading: false,

              status2: [{
                value: 0,
                label: '默认'
              }, {
                value: 1,
                label: '正常'
              }, {
                value: 2,
                label: '被禁用'
              }],

                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                  businessCode:'',

                    name:'',
                    idCard:'',
                    serveCode:'',
                  status:'',
                  phone:'',

                },

                rules:{
                    phone:[
                        { required: true, message: '请输入手机号', trigger: 'blur' },
                        {
                            pattern: /^1[3456789]\d{9}$/,
                            message: '请输入正确的手机号'
                        },
                    ],
                    name:[
                        { required: true, message: '请输入商家名称', trigger: 'blur' },
                    ],
                     idCard:[
                       { required: true, message: '请输入身份证号', trigger: 'blur' },
                        //{ required: false,validator: validatorIdNumber, trigger: 'blur' }
                    ],
                  businessCode:[
                    { required: true, message: '请选择商家', trigger: 'blur' },
                  ],


                },

            }
        },

        methods: {
            init(row){
              this.$refs.editForm.resetFields();

              this.editForm.name=row.name
              this.editForm.phone=row.phone
              this.editForm.idCard=row.idCard
              this.editForm.serveCode=row.serveCode
              this.editForm.status = row.status;
              this.editForm.businessCode = row.businessCode;

            },

            closeSelf() {
                this.$emit("closeEdit");
            },


            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        this.$message({type: 'info', message: '请完善信息'});
                        return false;
                    }
                })

            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }
                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Serve/EditByGov",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },


        }
    }


</script>
<style lang="scss" scoped>

</style>
